import React from "react";
import {
  UpdatePageMutationVariables,
  usePageQuery,
  useUpdatePageMutation,
} from "../../generated/graphql";
import { useToast } from "@chakra-ui/react";
import Loading from "../../components/loading/Loading";
import { Navigate, useNavigate } from "react-router-dom";
import Form from "./Form";

interface Props {
  id: string;
}

const Update: React.VFC<Props> = ({ id }) => {
  const [updatePage] = useUpdatePageMutation();
  const navigation = useNavigate();
  const toast = useToast();

  const { loading, error, data } = usePageQuery({
    variables: {
      where: {
        id,
      },
    },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Navigate to={"/page"} replace />;
  }

  const handleUpdatePage = async (data: UpdatePageMutationVariables) => {
    try {
      await updatePage({
        variables: {
          ...data,
        },
      });

      return toast({
        status: "success",
        title: "Başarılı",
        description: "Page updated",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/page");
        },
      });
    } catch (error: any) {
      console.log(error.message);
      return toast({
        status: "error",
        title: "Hata",
        description: "An error occured",
        duration: 1000,
      });
    }
  };

  return (
    <Form
      actionType="UPDATE"
      data={data?.page}
      id={id}
      handleUpdatePage={handleUpdatePage}
    />
  );
};

export default Update;
